<template src="./GridRowExpanded.html"></template>
<style scoped src="./GridRowExpanded.scss" lang="scss"></style>
<script>
import gsap from "gsap";

export default {
  props: {
    item: Object,
    visible: Boolean
  },
  data: function() {
    return {
      isFullDesplegado: false
    };
  },
  watch: {
    // visible(newValue, oldValue) {
    // },
    item() {
      if (!this.visible) return false;
      if (!this.isFullDesplegado) return false;
      gsap.fromTo(
        this.$refs.ficha,
        {
          opacity: 0
        },
        {
          opacity: 1,
          duration: 0.7
        }
      );
    }
  },
  methods: {
    showDetail() {
      // this.$el.classList.add("visible");
    },
    getExpandedHeight() {
      return this.$el.scrollHeight;
    },
    close() {
      this.$emit("expanded_closed");
    },
    enter(el, done) {
      gsap.fromTo(
        el,
        {
          opacity: 0
        },
        {
          duration: 2,
          opacity: 1,
          onComplete: () => {
            this.isFullDesplegado = true;
            done();
          }
        }
      );
    },
    afterEnter() {
      this.isAnimating = false;
    },
    afterLeave() {},
    leave(el, done) {
      this.isFullDesplegado = false;
      gsap.to(el, {
        duration: 0.5,
        opacity: 0,
        onComplete: done
      });
    },
    playVideo() {
      this.$store.dispatch("activeVideoCinema", {
        activo: true,
        item: this.item,
        preview: false
      });
    }
  }
};
</script>
